import { render, staticRenderFns } from "./PlosR_Search.vue?vue&type=template&id=4a018a2b"
import script from "./PlosR_Search.vue?vue&type=script&lang=js"
export * from "./PlosR_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports